import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupSharedActions" */ './lazyIndex');
});
export var lazyLoadGroupAction = new LazyAction(lazyModule, function (m) { return m.loadGroupAction; });
export var lazyOnAfterNewGroupSelected = new LazyAction(lazyModule, function (m) { return m.onAfterNewGroupSelectedAction; });
export var lazyOnAfterGroupDetailsSucceeded = new LazyAction(lazyModule, function (m) { return m.onAfterGroupDetailsSucceededAction; });
export var lazySetGroupIsSubscribed = new LazyAction(lazyModule, function (m) { return m.setGroupIsSubscribedAction; });
export var lazySetGroupIsMember = new LazyAction(lazyModule, function (m) { return m.setGroupIsMemberAction; });
//# sourceMappingURL=index.js.map